import { Stack, Tooltip, Typography } from '@mui/material';
import { Image } from '@retail/components';

import { RoundingRuleCondition } from '@retail/calculus/types';
import { useRoundingTFunction } from '@retail/rounding/i18n';

interface Props {
  roundingCondition: RoundingRuleCondition;
}

export const RoundingConditionInfo = ({ roundingCondition }: Props) => {
  const t = useRoundingTFunction();
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography variant="body2" fontWeight="bold">
        {roundingCondition.ruleSetName}
      </Typography>
      {roundingCondition.centralOwner && (
        <Tooltip
          title={t('rounding.ruleOwner.central', {
            owner: roundingCondition.centralOwner.name,
          })}
        >
          <Image
            src={roundingCondition.centralOwner.imgUrl}
            alt={roundingCondition.centralOwner.name}
            width={20}
            height={20}
          />
        </Tooltip>
      )}
    </Stack>
  );
};
